<template>
  <section>
    <el-row style="padding:15px;background:#fff">
      <el-col :sm="24" :xs="24">
        <el-row :gutter="10">
          <el-select class="xs24" v-model="pdata.type" placeholder="请选择小游戏类型" @change="getList">
            <el-option label="请选择小游戏类型" value></el-option>
            <el-option :label="v" :value="v" v-for="(v,i) in product_theme" :key="i"></el-option>
          </el-select>
          <el-select class="xs24" v-model="pdata.source" placeholder="请选择小游戏来源" @change="getList" clearable >
          	<el-option :label="v" :value="v" v-for="(v,i) in issued_app_source" :key="i"></el-option>

          </el-select>

          <el-input
            @clear="getList"
            @keyup.enter.native="search"
            ref="input"
            class="search xs24"
            v-model="pdata.kw"
            clearable
            placeholder="请输入小程序名称"
            :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
          ></el-input>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="statusRow">
      <el-button size="small" type="primary" @click="addProduct">新增</el-button>
      <el-button size="small" type="success" @click="changeStatus(false,1)">启用</el-button>
      <el-button size="small" type="danger" @click="changeStatus(false,0)">禁用</el-button>
      <el-button size="small" type="info" @click="changeStatus(false,-1)">删除</el-button>
    </el-row>
    <!--列表-->
    <el-table
      :data="plist"
      style="width: 100%;min-width:1600px"
      stripe
      row-key="id"
      @selection-change="select"
    >
      <el-table-column type="selection" min-width="30px"></el-table-column>
      <el-table-column prop="id" label="ID" min-width="40px" align="center"></el-table-column>
      <el-table-column prop="name" label="小程序名称" min-width="100px" align="left">
        <template slot-scope="scope">
          <el-button type="text" @click="editProduct(scope.row)">{{scope.row.name}}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="rename" label="曾用名"  align="center"></el-table-column>
      <el-table-column prop="icon" label="图标" min-width="85px" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.icon" alt class="gameIcon">
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" min-width="60px" align="center"></el-table-column>
      <el-table-column prop="source" label="来源" min-width="80px" align="center"></el-table-column>
      <el-table-column prop="body" label="主体" min-width="40px" align="center"></el-table-column>
      <el-table-column prop="appid" label="APPID" min-width="140px" align="center"></el-table-column>
      <el-table-column prop="email" label="邮箱" min-width="120px" align="center"></el-table-column>
      <el-table-column prop="divide" label="分成方式" min-width="80px" align="center"></el-table-column>
      <el-table-column prop="password" label="密码" min-width="100px" align="center"></el-table-column>
      <el-table-column prop="appsecret" label="APPSECRET" min-width="200px" align="center"></el-table-column>

      <el-table-column prop="status" label="产品状态" min-width="80px" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            :type="scope.row.status=='1'?'success':'danger'"
            @click="changeStatus(true,scope.row)"
          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>

    <el-dialog
      :title="isAdd?'新增产品信息':'编辑产品信息'"
      :visible.sync="editDialog"
      top="5vh"
      width="700px"
      custom-class="dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="chooseProduct" :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
        <el-form-item label="小游戏名称" prop="name" class="inline">
          <el-input v-model="chooseProduct.name" placeholder="小游戏名称" class="input" clearable></el-input>
        </el-form-item>
        <el-form-item label="短名称" prop="short_name" class="inline">
          <el-input v-model="chooseProduct.short_name" placeholder="短名称" class="input" clearable></el-input>
        </el-form-item>
        <el-form-item label="曾用名" prop="rename" class="inline">
          <el-input v-model="chooseProduct.rename" placeholder="曾用名" class="input" clearable></el-input>
        </el-form-item>
        <el-form-item label="APPID" prop="appid" class="inline">
          <el-input v-model="chooseProduct.appid" placeholder="请输入小游戏appid" class="input" clearable></el-input>
        </el-form-item>
        <el-form-item label="APPSECRET" class="inline" prop="appsecret">
          <el-input
            v-model="chooseProduct.appsecret"
            placeholder="请输入APPSECRET"
            class="input"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" class="inline" prop="email">
          <el-input v-model="chooseProduct.email" placeholder="请输入邮箱" class="input" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码" class="inline" prop="password">
          <el-input v-model="chooseProduct.password" placeholder="请输入密码" class="input" clearable></el-input>
        </el-form-item>
        <!--<el-form-item label="不扣量阿拉丁key"  prop="ald_app_key">
          <el-input style="width: 320px !important;" v-model="chooseProduct.ald_app_key" placeholder="请输入不扣量阿拉丁key" class="input" clearable></el-input>
        </el-form-item>
        <el-form-item label="扣量阿拉丁key"  prop="ald_app_key_o">
          <el-input style="width: 320px !important;" v-model="chooseProduct.ald_app_key_o" placeholder="请输入扣量阿拉丁key" class="input" clearable></el-input>
        </el-form-item>-->
        <el-form-item label="游戏图标" prop="icon" >
          <UploadImg :image="chooseProduct.icon" v-on:update:image="chooseProduct.icon=$event"></UploadImg>
        </el-form-item>
        <el-form-item label="游戏类型">
          <el-radio-group v-model="chooseProduct.type">
            <el-radio :label="v" :value="v" v-for="(v,i) in product_theme" :key="i"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="主体">
          <el-radio-group v-model="chooseProduct.body">
            <el-radio :label="v" :value="v" v-for="(v,i) in app_body" :key="i"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="游戏来源">
           <el-radio-group v-model="chooseProduct.source">
					    <el-radio :label="v" :value="v"  v-for="(v,i) in issued_app_source" :key="i"></el-radio>
					  </el-radio-group>
        </el-form-item>
        <el-form-item label="分成公司">
	        <el-select v-model="chooseProduct.cp_company_id" filterable  clearable    placeholder="请选择分成公司名称">
			    <el-option
			      v-for="item in companyList"
			      :key="item.id"
			      :label="item.name"
			      :value="item.id">
			    </el-option>
				</el-select>
			 </el-form-item>
        <el-form-item label="分成方式">
          <el-radio-group v-model="chooseProduct.divide">
				    <el-radio label="原生">原生</el-radio>
				    <el-radio label="利润">利润</el-radio>
				  </el-radio-group>
        </el-form-item>
        <el-form-item label="分成占比" class="inline" prop="divide_per" v-if="chooseTags.length>0">
          <el-input
            v-model="chooseProduct.divide_per"
            placeholder="请输入分成占比"
            class="input"
            clearable
          ></el-input>
          	（给到对方的分成占比）
        </el-form-item>
        <el-form-item label="小游戏数据采集账号">
           <el-radio-group v-model="chooseProduct.game_miniprogram_account">
					    <el-radio :label="i" :value="i"  v-for="(v,i) in game_miniprogram_account" :key="i">{{v}}</el-radio>
					  </el-radio-group>
        </el-form-item>
         <el-form-item label="实时曲线图">
          <el-radio-group v-model="chooseProduct.real_time_chart">
            <el-radio label="1" value="1">开启</el-radio>
            <el-radio label="0" value="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        
         <el-form-item label="是否是盒子">
          <el-radio-group v-model="chooseProduct.isbox">
            <el-radio label="1" value="1">盒子</el-radio>
            <el-radio label="0" value="0">非盒子</el-radio>
          </el-radio-group>
        </el-form-item>
         <el-form-item label="平台标识">
           <el-radio-group v-model="chooseProduct.platform_id">
					    <el-radio :label="i+1" :value="i+1"  v-for="(v,i) in  get_issued_app_platform" :key="i+1">{{v}}</el-radio>
					  </el-radio-group>
        </el-form-item>
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import { getPlist, getPAdd, getPEdit, getPStatus,getCPCompanyList } from "../../api/api";
// import { splist, saddp, spstatus, splog, seditp, scopy } from "../api/api";
import UploadImg from "../uploadImg.vue";

export default {
  components: {
    UploadImg
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
        short_name: [
          { required: true, message: "请输入短名称", trigger: "blur" }
        ],
        appid: [
          { required: true, message: "请输入产品appid", trigger: "blur" }
        ],
        icon: [{ required: true, message: "请上传产品图片", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // divide_per: [
        //   { required: true, message: "请输入分成占比", trigger: "blur" }
        // ],
        appsecret: [
          { required: true, message: "请输入appsecret", trigger: "blur" }
        ]
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        type: "",
        source: "",
        kw: ""
      },
      plist: [],
      maxPage: 1,
      product_theme: [], //游戏类型
      app_body: [], //游戏主体
      tags: [], //游戏标签
      issued_app_source:[],//游戏来源 
      game_miniprogram_account:[], //游戏采集账号
      chooseProduct: {},
      editDialog: false,
      formLabelWidth: "120px",
      chooseTags: [],
      plog: [], //日志
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      imageUrl: "",

      headMsg: {
        token: ""
      },
      imageUrl: "",
      isAdd: false,
      cP: {
        app_id: "",
        status: "1",
        log: ""
      }, //修改选中的产品状态,批量修改状态
      companyList:[],
    };
  },
  watch: {
    "chooseTags.length": {
      handler(n, o) {
        this.chooseProduct.divide = this.chooseTags.join(",");
      },
      deep: true
      // immediate: true
    }
  },
  methods: {
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      p = p.slice(0, -1);
      getPlist(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.plist = res.data.list;
          this.maxPage = res.data.max_page;
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.product_theme = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.app_body = this.$store.config.app_body;
        this.game_miniprogram_account= this.$store.config.game_miniprogram_account; //游戏采集账号
        this.issued_app_source=this.$store.config.issued_app_source; //游戏来源
        this.get_issued_app_platform = this.$store.config.get_issued_app_platform; //发行账号平台标识
        if( this.game_miniprogram_account.indexOf('无')==-1){
        	this.game_miniprogram_account.unshift('无');
        }
       // this.game_miniprogram_account.unshift('无');
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    search() {
      // this.$refs.input.blur();
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editProduct(d) {
      this.editDialog = true;
      this.chooseProduct = JSON.parse(JSON.stringify(d));
      this.chooseProduct.app_id = this.chooseProduct.id;
      this.chooseProduct.game_miniprogram_account = parseInt(this.chooseProduct.game_miniprogram_account);
       this.chooseProduct.platform_id = parseInt(this.chooseProduct.platform_id);
      this.chooseTags = this.chooseProduct.divide.split(",");
      this.isAdd = false;
    },
    changeStatus(isSingle, s) {
      this.$prompt("请输入编辑原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
        inputErrorMessage: "内容不能为空"
      }).then(({ value }) => {
        if (isSingle) {
          this.cP.app_id = s.id;
          this.cP.status = s.status == 1 ? "0" : "1";
        } else {
          this.cP.status = s;
        }
        this.cP.log = value;
        getPStatus(this.cP, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.getList();
            this.$message({ message: "状态修改成功", type: "success" });
          }
        });
      });
    },
    addProduct() {
      this.chooseProduct = {
        name: "",
        short_name: "",
        rename: "",
        icon: "",
        type: "休闲",
        source: "内部游戏",
        cp_company_id:'',
        divide: "原生",
        divide_per: "",
        body: "个人",
        appid: "",
        email: "",
        appsecret: "",
        game_miniprogram_account: 0,
        ald_app_key: "",
        log: "新增产品",
        real_time_chart:"0",
        isbox:"0", //是否是盒子
      };
      this.editDialog = true;
      this.chooseTags = ["原生"];
      this.isAdd = true;
    },
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (!this.isAdd) {
            this.chooseProduct.log = "编辑内容";
          }
          getPAdd(this.chooseProduct, this.$cookie.getCookie("login")).then(
            res => {
              if (res.code == 200) {
                this.getList();
                this.editDialog = false;
              } else {
                this.$message.error(res.msg);
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    select(s) {
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.app_id = p.slice(2);
    },
    openDealy(id) {
      splog(id, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getInfo(s) {
      this.chooseProduct = JSON.parse(JSON.stringify(s));
      this.chooseTags = this.chooseProduct.tags.split(",");
    }
  },
  mounted() {
    this.getList();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    getCPCompanyList('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data&&res.data.list.length>0){
        		this.companyList = res.data.list;
        	}
          
        }
      });
    // scopy("我的", this.$cookie.getCookie("login")).then(res => {});
  }
};
</script>
<style scoped>
.dialog {
  width: 800px;
}
</style>

<style>

.gameIcon {
  width: 60px;
  height: 60px;
}
.dropdown {
  min-width: 120px;
  width: 170px;
}
.dropdown-menu {
  width: 170px;
  margin: 0 auto;
  text-align: center;
}
.search,
.input {
  width: 200px;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.pagination {
  /* float: right; */
  /* margin-top: 30px; */
  /* min-width: 1200px; */
  padding: 20px;
}
.el-upload-list__item {
  line-height: 0;
}
.el-radio {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// pList.vue?3cf80d68